export default __webpack_public_path__ + "static/media/call.4ac63733.svg";